import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d3881c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "multi-position-panel" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("水平均匀分布")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("垂直均匀分布")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("组合")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消组合")

import { ElementAlignCommands } from '@/types/edit'
import useCombineElement from '@/hooks/useCombineElement'
import useAlignActiveElement from '@/hooks/useAlignActiveElement'
import useAlignElementToCanvas from '@/hooks/useAlignElementToCanvas'
import useUniformDisplayElement from '@/hooks/useUniformDisplayElement'


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiPositionPanel',
  setup(__props) {

const { canCombine, combineElements, uncombineElements } = useCombineElement()
const { alignActiveElement } = useAlignActiveElement()
const { alignElementToCanvas } = useAlignElementToCanvas()
const { displayItemCount, uniformHorizontalDisplay, uniformVerticalDisplay } = useUniformDisplayElement()

// 多选元素对齐，需要先判断当前所选中的元素状态：
// 如果所选元素为一组组合元素，则将它对齐到画布；
// 如果所选元素不是组合元素或不止一组元素（即当前为可组合状态），则将这多个（多组）元素相互对齐。
const alignElement = (command: ElementAlignCommands) => {
  if (canCombine.value) alignActiveElement(command)
  else alignElementToCanvas(command)
}

return (_ctx: any,_cache: any) => {
  const _component_IconAlignLeft = _resolveComponent("IconAlignLeft")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_IconAlignHorizontally = _resolveComponent("IconAlignHorizontally")!
  const _component_IconAlignRight = _resolveComponent("IconAlignRight")!
  const _component_ButtonGroup = _resolveComponent("ButtonGroup")!
  const _component_IconAlignTop = _resolveComponent("IconAlignTop")!
  const _component_IconAlignVertically = _resolveComponent("IconAlignVertically")!
  const _component_IconAlignBottom = _resolveComponent("IconAlignBottom")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_IconGroup = _resolveComponent("IconGroup")!
  const _component_IconUngroup = _resolveComponent("IconUngroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ButtonGroup, { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "左对齐"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (alignElement(_unref(ElementAlignCommands).LEFT)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignLeft)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "水平居中"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (alignElement(_unref(ElementAlignCommands).HORIZONTAL)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignHorizontally)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "右对齐"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (alignElement(_unref(ElementAlignCommands).RIGHT)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignRight)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }),
    _createVNode(_component_ButtonGroup, { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "上对齐"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[3] || (_cache[3] = ($event: any) => (alignElement(_unref(ElementAlignCommands).TOP)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignTop)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "垂直居中"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[4] || (_cache[4] = ($event: any) => (alignElement(_unref(ElementAlignCommands).VERTICAL)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignVertically)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "下对齐"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[5] || (_cache[5] = ($event: any) => (alignElement(_unref(ElementAlignCommands).BOTTOM)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignBottom)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }),
    (_unref(displayItemCount) > 2)
      ? (_openBlock(), _createBlock(_component_ButtonGroup, {
          key: 0,
          class: "row"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(uniformHorizontalDisplay)()))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(uniformVerticalDisplay)()))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Divider),
    _createVNode(_component_ButtonGroup, { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_component_Button, {
          disabled: !_unref(canCombine),
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(combineElements)())),
          style: {"flex":"1"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconGroup, { style: {"margin-right":"3px"} }),
            _hoisted_4
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_Button, {
          disabled: _unref(canCombine),
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(uncombineElements)())),
          style: {"flex":"1"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconUngroup, { style: {"margin-right":"3px"} }),
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    })
  ]))
}
}

})